import React, { useState, useEffect } from 'react';
import './AnswersInsidePage.css';
import { AiOutlineCloudDownload } from "react-icons/ai";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    Button,
    Paper, Tooltip, Backdrop, CircularProgress
} from '@mui/material';
import { InteractiveMapSaagento } from "../InteractiveMap/InteractiveMapSaagento";
import RewriteRequest from "../../components/CaseInsideTable/RewriteRequest";
import PermitTypeDisplayForAdmin from "../../components/CaseInsideTable/PermitTypeDisplayForAdmin";
import { FaMapMarkedAlt } from "react-icons/fa";
import LoaderCustomFixed from "../../components/ConfirmationModal/LoaderCustomFixed";
import { jwtDecode } from "jwt-decode";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useFeatureExists } from "../../pages/InteractiveMap/useFeatureExists";
import CaseStatus, {findStatusTitleById} from "../../enums/CaseStatus"; // adjust path as needed

const AnswersInsidePage = () => {
    const [caseData, setCaseData] = useState(null);
    const [userCaseFiles, setUserCaseFiles] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);
    const location = useLocation();
    const { t } = useTranslation();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [showUpload, setShowUpload] = useState(false);
    const navigate = useNavigate();
    const token = localStorage.getItem('jwtToken');
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [departmentID, setDepartmentID] = useState(null);
    const featureExists = useFeatureExists(caseData); //ცვლადი იმის შესამოწმებლად აქვს თუ არა გრაფიკა

    const fetchPermitType = async () => {
        try {
            const response = await axios.get(`https://localhost:7268/WeatherForecast`);
            setDepartmentID(response.data.data.orderDepartment)

        } catch (error) {
        }
    };

    useEffect(() => {
        if (caseData && departmentID === null) {
            void fetchPermitType();
        }
    }, [caseData]);

    useEffect(() => {

        if (token && caseData) {
            const user = jwtDecode(token)
            const userId = user.UserId
            const role = user.role
            setShowUpload((!(userId === caseData.requesterId) && role === "USER"))
        }
    }, [caseData, token]);

    const handleCheckboxChange = (file) => {
        setSelectedFiles(prevSelectedFiles => {
            const isFileSelected = prevSelectedFiles.some(f => f.id === file.id);
            if (isFileSelected) {
                return prevSelectedFiles.filter(f => f.id !== file.id);
            } else {
                return [...prevSelectedFiles, file];
            }
        });
    };

    const handleDownload = async () => {
        setIsDownloading(true);
        const payload = {
            casefileIds: selectedFiles.map(file => file.id)
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CaseSharedFilesDocumentsDownloadZip`, payload, {
                responseType: 'blob',
            });

            const file = new Blob([response.data], {
                type: 'application/zip'
            });

            const fileURL = URL.createObjectURL(file);

            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', "განაცხადი N" + caseData.caseNumber);
            document.body.appendChild(fileLink);

            fileLink.click();

            fileLink.parentNode.removeChild(fileLink);
        } catch (error) {
        }
        finally {
            setIsDownloading(false);
        }
    };

    const useQuery = () => {
        return new URLSearchParams(location.search);
    };

    const query = useQuery();
    const caseID = query.get('id');

    useEffect(() => {
        let didCancel = false;

        const fetchData = async () => {
            setIsLoading(true);
            try {

                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetCaseByIdByuser`, {
                    params: {
                        Id: caseID
                    },
                });
                if (response.data.success) {
                    setCaseData(response.data.data);
                }

                const response2 = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllCaseSharedFileByCaseID`, {
                    params: {
                        CaseId: caseID
                    },
                });
                setUserCaseFiles(response2.data.data);
                if (!didCancel) {
                    setUserCaseFiles(response2.data.data);
                }

            } catch (error) {
            } finally {
                if (!didCancel) {
                    setIsLoading(false); // Stop loading
                }
            }
        };

        void fetchData();

        return () => {
            didCancel = true;
        };
    }, []);


    const formatDate = (dateString) => {
        if (dateString === '0001-01-01T00:00:00') {
            return 'თარიღი არ მოიძებნა';
        }

        const date = new Date(dateString);
        if (isNaN(date)) {
            return 'თარიღი არ მოიძებნა';
        }

        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    };


    if (isLoading) {
        return <div>
            <div style={{ marginTop: 400 }}>
                <LoaderCustomFixed />
            </div>
            <div style={{ marginTop: 400 }}></div>
        </div>;
    }
    if (!caseData || !userCaseFiles) {
        return <div>არაფერი მოიძებნა 404</div>;
    }


    const handleSelectAllChange = (event) => {
        if (event.target.checked) {
            setSelectedFiles(userCaseFiles);
        } else {
            setSelectedFiles([]);
        }
    };


    return (
        <Box className={"answers-inside-page-container"}>
            {caseData && (<PermitTypeDisplayForAdmin id={caseData.permitTypeId} />)}
            <Backdrop open={isDownloading} style={{ zIndex: 1000 }}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <TableContainer className={"answers-inside-info-table"} component={Paper}>
                <Table aria-label="case data table">
                    <TableHead className={"answers-inside-info-table-header"}>
                        <TableRow>
                            <TableCell align="center">{t("განაცხადის ნომერი")}</TableCell>
                            <TableCell align="center">{t("სტატუსი")}</TableCell>
                            <TableCell align="center">{t("რეგიონი")}</TableCell>
                            <TableCell align="center">{t("მუნიციპალიტეტი")}</TableCell>
                            <TableCell align="center">{t("საკრებულო")}</TableCell>
                            <TableCell align="center">{t("დასახლებული პუნქტი")}</TableCell>
                            <TableCell align="center">{t("განაცხადის თარიღი")}</TableCell>
                            <TableCell align="center">{t("დასრულების თარიღი")}</TableCell>
                            <TableCell
                                className={"answers-inside-info-table-head-cells"}>{t("რუკაზე ნახვა")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell align="center">{caseData.caseNumber}</TableCell>
                            <TableCell align="center">{findStatusTitleById(caseData.status, departmentID === 3)}</TableCell>
                            <TableCell align="center">{caseData.regionsNames}</TableCell>
                            <TableCell align="center">{caseData.citysNames}</TableCell>
                            <TableCell align="center">{caseData.councilsNames}</TableCell>
                            <TableCell align="center">{caseData.populatedAreasNames}</TableCell>
                            <TableCell align="center">{formatDate(caseData.createDate)}</TableCell>
                            <TableCell align="center">{formatDate(caseData.dedline)}</TableCell>
                            {featureExists && (
                                <td
                                    onClick={() => window.open(`/interactivemap?id=${caseData.id.toString()}`, '_blank')}
                                    title={caseData.caseNumber}
                                    className="table-url"
                                >
                                    <FaMapMarkedAlt style={{ fontSize: 41 }} />
                                </td>
                            )}
                            {/* <TableCell>
                                <td onClick={() => navigate("/interactivemap?id=" + caseData.id.toString())}
                                    title={caseData.caseNumber}
                                    className={"table-url"}><FaMapMarkedAlt
                                        style={{ fontSize: 41 }} /></td>
                            </TableCell> */}

                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <Box>
                <Box className="answers-inside-page-secondary-content">
                    <TableContainer style={{ maxHeight: 500, overflow: 'auto' }} component={Paper}>
                        <Table aria-label="file list table">
                            <TableHead className={"answers-inside-file-table-header"}>
                                <TableRow>
                                    <TableCell>
                                        <Checkbox
                                            type="checkbox"
                                            checked={selectedFiles.length === userCaseFiles.length}
                                            onChange={handleSelectAllChange}
                                        />
                                    </TableCell>
                                    <TableCell>ფაილის დასახელება</TableCell>
                                    <TableCell>აიტვირთა</TableCell>
                                    <TableCell>
                                        <Tooltip
                                            title="გადმოსაწერად ამოირჩიეთ დოკუმენტები"
                                            disableHoverListener={selectedFiles.length !== 0}
                                        >
                                            <div
                                                style={{ cursor: selectedFiles.length === 0 ? "not-allowed" : "pointer" }}>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    startIcon={<CloudDownloadIcon />}
                                                    onClick={handleDownload}
                                                    disabled={isDownloading || selectedFiles.length === 0}
                                                    style={{ width: 250 }}
                                                >
                                                    {isDownloading ? "გთხოვთ დაელოდოთ..." : "გადმოწერა"}
                                                </Button>
                                            </div>
                                        </Tooltip>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody style={{
                                height: "400px",
                                overflow: "auto"
                            }}>
                                {userCaseFiles.map(file => (
                                    <TableRow key={file.id}>
                                        <TableCell>
                                            <Checkbox
                                                type="checkbox"
                                                onChange={() => handleCheckboxChange(file)}
                                                checked={selectedFiles.some(f => f.id === file.id)}
                                            />

                                        </TableCell>
                                        <TableCell>{file.name}</TableCell>
                                        <TableCell>{formatDate(file.createdAt)}</TableCell>
                                        <TableCell align={"center"}>
                                            <Button
                                                href={file.path}
                                                target="_blank"
                                                startIcon={<AiOutlineCloudDownload />}
                                            >
                                                {t("ნახვა")}
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box className="answers-inside-page-gray-square">
                        <InteractiveMapSaagento />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default AnswersInsidePage;
